<template>
  <div>
    <Vidle
      v-if="interval > 0"
      @idle="onIdle"
      @remind="onRemind"
      :syncKey="userId"
      :loop="true"
      :reminders="[interval / 2]"
      :duration="interval"
      class="vidle-zero"
    />
  </div>
</template>
<script>
import Vidle from 'v-idle'
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'

import { bus } from '../../main'
import apiAuth from '@/apis/auth'

import { getRefreshToken } from '@/utils/auth'

export default {
  components: {
    Vidle
  },
  data() {
    return {
      logoutMessage: 'The session timed out. Please log in again.',
      exclude: ['Realtime'],
      interval: 15 * 60,
      userId: ''
    }
  },
  computed: {
    ...mapGetters('general', ['general']),
    ...mapGetters('auth', ['user'])
  },
  watch: {
    'general.session_timeout': {
      immediate: true,
      handler(val) {
        this.interval = this.general.session_timeout * 60
        this.userId = this.user._id
      }
    }
  },
  methods: {
    onIdle() {
      const pageName = this.$route.name
      if (!this.interval) return
      if (this.exclude.includes(pageName)) {
        setTimeout(() => {
          const refresh_token = getRefreshToken()
          if (!refresh_token) this.forceLogout()
        }, 20)
      } else {
        this.forceLogout()
      }
    },
    onRemind() {
      // if (!this.interval) return
    },
    forceLogout() {
      bus.$emit('isCallEnded', false)
      clearInterval(this.intervalId)
      this.$store.dispatch('auth/logout')
      this.$router.replace({
        name: 'Login',
        params: { email: this.user.email, error: this.logoutMessage }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.vidle-zero {
  height: 0px !important;
  overflow: hidden;
  padding: 0 !important;
  margin: 0 !important;
}
</style>
